export const tips = (self, status, text) => {
  const type = status ? "success" : "error";
  const msg = text || (status ? "操作成功" : "操作失败");
  self.$message?.[type](msg);
};
export const confirm = (self, {
  okBack = () => {
  }, title = "提示", content, okText = "确认", okType, cancelText = "取消"
}) => {
  self.$confirm({
    title,
    content,
    okText,
    okType,
    cancelText,
    maskClosable: false,
    onOk() {
      okBack && okBack();
    },
    onCancel() {
    }
  });
};

